module.exports = __webpack_public_path__ + "static/media/CEA_TAUX_CONDITIONS_2025.0376cfa0.pdf";